import { useAppDispatch, useAppSelector } from "app/hooks"
import { useFailed, useSuccess } from "features/notification/hooks"
import { MealType } from "model/food/types"
import getMealPayloadFromMeal from "model/food/utils/getPayloads/getMealPayloadFromMeal"
import { createFavoriteMeal } from "../favoriteMealsSlice"

export const useCreateFavoriteMeal = (callback?: () => void) => {
  const createFavoriteMealLoading = useAppSelector(
    (state) => state.favoriteMeals.createFavoriteMealLoading,
  )
  const createFavoriteMealFailed = useAppSelector(
    (state) => state.favoriteMeals.createFavoriteMealFailed,
  )
  const createFavoriteMealSuccess = useAppSelector(
    (state) => state.favoriteMeals.createFavoriteMealSuccess,
  )

  const dispatch = useAppDispatch()

  const handleCreateFavoriteMeal = (meal: MealType) => {
    let mealPayload = getMealPayloadFromMeal(meal)
    mealPayload.isManualNutrition = meal.isManualNutrition

    if (mealPayload) {
      dispatch(createFavoriteMeal(mealPayload))
    }
  }

  useFailed(createFavoriteMealFailed)
  useSuccess(createFavoriteMealSuccess, { message: "" }, callback)

  return {
    createFavoriteMealLoading,
    handleCreateFavoriteMeal,
  }
}

export default useCreateFavoriteMeal
